import React, { Fragment, useEffect, useMemo } from 'react';
import { browserHistory } from 'react-router';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import SimpleAvatar from '../../common/SimpleAvatar';
import Loader from '../../common/Loader';
import Shape from '../../common/Shape';
import AppointmentHeader from '../Components/AppointmentHeader';
import AddNewUser from './AddNew';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

function AppointmentUsers({
  clearHealthPlans,
  clearProgress,
  fetchCareUsers,
  fetchSchedulingTree,
  finishValidate,
  formatMessage,
  loading,
  location: { hash },
  setCareUser,
  users,
  setDependentSubmitRedirect,
}) {
  const activeUserId = useMemo(() => hash.replace('#', ''), [hash]);

  usePageView('Get Care | Who needs care?');

  useEffect(() => {
    clearProgress();
    clearHealthPlans();
    finishValidate();
    fetchCareUsers();
  }, []);

  const handleUserSelect = user => {
    fetchSchedulingTree({ userId: user.id, schedulingBy: 'patient' });
    setCareUser(user);
  };

  function renderName(user, meta) {
    return () =>
      meta.isMe
        ? formatMessage({ id: 'appointments.form.book4me' })
        : user.displayableName;
  }

  function renderAvatar(user) {
    return () => (
      <SimpleAvatar
        src={get(user, 'avatar.thumbMin')}
        text={user.displayableName}
        size={44}
        bordered
      />
    );
  }

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.users" />

      <AppointmentHeader
        title="appointments.form.step1.title"
        subtitle="appointments.form.step1.subTitle"
        handleBack={browserHistory.goBack}
      />

      <div>
        {users.map(({ id, user, metadata }) => {
          if (!metadata.appointmentSchedulingAllowed) {
            return null;
          }
          return (
            <Shape
              renderPrimary={renderName(user, metadata)}
              onClick={() => handleUserSelect(user)}
              renderLeft={renderAvatar(user)}
              active={id.toString() === activeUserId}
              key={id}
            />
          );
        })}
        {!loading && (
          <AddNewUser
            formatMessage={formatMessage}
            setDependentSubmitRedirect={setDependentSubmitRedirect}
          />
        )}
        {loading && <Loader />}
      </div>
    </Fragment>
  );
}

AppointmentUsers.propTypes = {
  fetchSchedulingTree: PropTypes.func,
  clearHealthPlans: PropTypes.func,
  fetchCareUsers: PropTypes.func,
  formatMessage: PropTypes.func,
  setCareUser: PropTypes.func,
  location: PropTypes.object,
  loading: PropTypes.bool,
  users: PropTypes.array,
  finishValidate: PropTypes.func,
  clearProgress: PropTypes.func,
  setDependentSubmitRedirect: PropTypes.func,
};

export default enhance(AppointmentUsers);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentUsers/index.jsx